"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SumSubPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var main_1 = require("../../../../reducers/slices/main");
var route_names_1 = require("../../../../constants/route_names");
var steps_1 = require("./constants/steps");
var get_user_details_1 = require("../../../../api/calls/user/get_user_details");
var application_1 = require("../../../../api/calls/lay-buy/application");
var page_path_1 = require("../../components/page_path");
var sampleAppController_1 = require("../../../../../facetec/src/sampleAppController");
var SumSubPage = function () {
    var params = (0, react_router_dom_1.useParams)();
    var laybuy_id = params.laybuy_id;
    //console.log("params", params);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var cookie = new universal_cookie_1.default();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = (0, react_1.useState)(true), isCheckingStatus = _b[0], setisCheckingStatus = _b[1];
    var _c = (0, react_1.useState)("Pending"), kycStatus = _c[0], setKycStatus = _c[1];
    (0, react_1.useEffect)(function () {
        if (user.uid) {
            var checkCookie = function () {
                setIsLoading(true);
                (0, get_user_details_1.get_user_details)().then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                if (!(response.success && ((_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.SumSubApproved) && ((_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.faceMatchUserInfo))) return [3 /*break*/, 2];
                                return [4 /*yield*/, (0, application_1.update_laybuy_application)({
                                        uid: laybuy_id,
                                        sumsub_complete: true,
                                    }).then(function (response) {
                                        setIsLoading(false);
                                        if (response.success) {
                                            window.scrollTo({
                                                top: 0,
                                                behavior: "smooth",
                                            });
                                            // TODO: update route constant
                                            navigate("".concat(route_names_1.ROUTE_LAYBUY_APPLICATION, "/").concat(steps_1.APP_STEP_PERSONAL_DETAILS, "/").concat(laybuy_id));
                                            setisCheckingStatus(false);
                                            clearInterval(intervalId_1);
                                            //navigate next
                                        }
                                        else {
                                            setIsLoading(false);
                                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
                                        }
                                    })];
                            case 1:
                                _c.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                setisCheckingStatus(false);
                                _c.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                setIsLoading(false);
            };
            // Use an interval to check for changes in the cookie
            var intervalId_1 = setInterval(checkCookie, 5000); // Check every second
        }
        //
    }, [user]);
    return (react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
        react_1.default.createElement(page_path_1.PagePath, { path: [
                {
                    page: "/",
                    title: "Home",
                },
                {
                    page: "#",
                    title: "Lay-buy Aplication",
                },
                {
                    title: "KYC",
                    active: true,
                },
            ] }),
        isCheckingStatus ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : (react_1.default.createElement("div", { className: "w-full" },
            react_1.default.createElement("div", { className: "flex flex-col gap-8 items-center" },
                react_1.default.createElement("div", { className: "flex justify-center" },
                    react_1.default.createElement("div", { className: "w-96 flex flex-col items-center gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { textColor: "text-black", label: "We need to verify your identity. Please proceed by clicking the Verify Identity button below.", center: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { textColor: "text-black", label: "You will need your ID Document to be able to do so.", center: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { textColor: "text-black", label: "The process will take about 2 minutes.", center: true }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { textColor: "text-black", label: "KYC Status: ".concat(kycStatus), center: true }))),
                react_1.default.createElement("div", { id: "status", className: "text-secondary hidden" }),
                react_1.default.createElement("div", { className: "w-48" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { loading: isLoading, enabled: !isLoading, label: "Verify Identity", backgroundColor: "bg-secondary", onClick: function () {
                            setIsLoading(true);
                            sampleAppController_1.SampleApp.onPhotoIDMatchPressed();
                        } })))))));
};
exports.SumSubPage = SumSubPage;
